import {CreditCard} from "./credit-card";

export class CreditCardMapper {

  public static map(data: any): CreditCard {
    const creditCard: CreditCard = new CreditCard();
    creditCard.id = data.id;
    creditCard.type = data.type.toLowerCase() === "american express" ? 'amex' : data.type.toLowerCase();
    creditCard.number = data.number;
    creditCard.expireMonth = data.expire_month;
    creditCard.expireYear = data.expire_year;
    creditCard.cvv = data.cvv2;

    return creditCard;
  }

}
